// /wallet-ops/orders — retired. SM-267 split this single tabbed page into
// per-domain routes: Deposits / Withdrawals under Transactions, Gas funding /
// Collections under Custody. This route stays only to redirect old bookmarks
// and the documented ?tab deep-link (e.g. from the treasury wallet detail) to
// their new home.
import { createFileRoute, redirect } from "@tanstack/react-router";

const TAB_TO_PATH = {
  deposits: "/wallet-ops/deposits",
  withdrawals: "/wallet-ops/withdrawals",
  gas: "/wallet-ops/gas",
  collections: "/wallet-ops/collections",
} as const;

type OrdersTab = keyof typeof TAB_TO_PATH;

export const Route = createFileRoute("/_app/wallet-ops/orders")({
  validateSearch: (search: Record<string, unknown>): { tab?: OrdersTab } => ({
    tab:
      typeof search.tab === "string" && search.tab in TAB_TO_PATH
        ? (search.tab as OrdersTab)
        : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: TAB_TO_PATH[search.tab ?? "deposits"],
      replace: true,
    });
  },
});
